import Vue from "vue";

const formatDuration = function (minutes,i18n) {
  let text = '';//i18n(`scheduler.duration.minutes`, minutes, {total: minutes});

  if (minutes >= 1440) {
    const days = Math.floor(minutes / 1440);
    // text = i18n(`common.duration.days.other`, days, {count: days}) + ' ';
    text = i18n(`common.duration.days.other`, {count: days}) + ' ';
    minutes = minutes - (days * 1440);
  }

  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60);

    if (hours === 1) {
      text += i18n(`common.duration.vue.one_hour`) + ' ';
    } else {
      text += i18n(`common.duration.vue.hours`, {hours: hours}) + ' ';
    }

    // text += i18n(`common.duration.hours.other`, hours, {count: hours}) + ' ';
  }

  const minutesInt = minutes % 60;
  if (minutesInt > 0) {
    text += i18n(`common.duration.vue.minutes`, {minutes: minutesInt});
    // text += i18n(`common.duration.minutes.other`, minutesInt, {count: minutesInt});
  }

  return text;
  // let i18nObjs = [];//i18n(`scheduler.duration.minutes`, minutes, {total: minutes});
  //
  // if (minutes >= 1440) {
  //   const days = Math.floor(minutes / 1440);
  //   i18nObjs.push([`scheduler.duration.days`, days, {total: days}]);
  //   minutes = minutes - (days * 1440);
  // }
  //
  // if (minutes >= 60) {
  //   const hours = Math.floor(minutes / 60);
  //   i18nObjs.push([`scheduler.duration.hours`, hours, {total: hours}]);
  // }
  //
  // const minutesInt = minutes % 60;
  // if (minutesInt > 0) {
  //   i18nObjs.push([`scheduler.duration.minutes`, minutesInt, {total: minutesInt}]);
  // }
  //
  // return i18nObjs;
};

Vue.filter('formatDuration', formatDuration);

export default formatDuration;
